import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PropagateLoader } from "react-spinners";
import { config } from "../../utils/config";
import { getCookie, setCookie } from "../../utils/cookieHandler";
import {
  addDefaultValuesToFields,
  extractFiles,
  findDataInFields,
  getDifferingValues,
  hasFileInput,
  mergeArrays,
} from "../../utils/helperFuctions";
import SimpleHeading from "../Headings/SimpleHeading";
import PopUp from "../PopUp/PopUp";
import ReusableForm from "../ReusableForm/ReusableForm";
import { updateShowFieldsByIndex } from "../../redux/showFieldsSlice";

const SingleRelatedCard = ({
  label,
  name,
  relatedParam,
  relatedParam2,
  fields,
  defaultValue,
  url,
  handleChange,
  filters,
  affectsOn,
  parentId,
  err,
  currentFields,
  setSingleRelatedFields,
  setSingleRelatedFieldsFormData,
  editId,
}) => {
  const [popupData, setpopupData] = useState({});
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [formKey, setFormKey] = useState(0); // Add a key state

  const initData = (defaultValue) => {
    if (defaultValue) {
      if (typeof defaultValue === "object") {
        return defaultValue;
      } else {
        return {
          id: defaultValue,
        };
      }
    }

    return {};
  };

  const addFilters = () => {
    if (filters) {
      let concatFilters = "";
      for (const key in filters) {
        if (Object.hasOwnProperty.call(filters, key)) {
          const element = filters[key];

          if (element.includes("<s>")) {
            concatFilters += key + "=" + element.replace("<s>", "") + "&";
          } else if (element.includes("<now>")) {
            concatFilters += key + "=" + new Date().toISOString() + "&";
          } else {
            //concatFilters += key + '=' + findDataInFields(currentFields,element) + '&';
          }
        }
      }

      return concatFilters;
    }

    return "";
  };

  const initFields = (defaultValue, fields) => {
    if (typeof defaultValue === "object") {
      return fields.map((e) => {
        if (e.name && defaultValue[e.name]) {
          const tempName = e.name;
          return { ...e, defaultValue: defaultValue[tempName] };
        }

        return e;
      });
    }

    return fields;
  };

  const getData = (url, id, defaultValue) => {
    try {
      axios
        .get(`${config.apiUrl}/api${url}/${id}?${addFilters(filters)}`, {
          headers: { Authorization: `Bearer ${getCookie("_AT")}` },
        })
        .then((d) => {
          if (d.headers?.authorization) {
            if (`Bearer ${getCookie("_AT")}` !== d.headers.authorization) {
              setCookie("_AT", d.headers.authorization.split(" ")[1]);
            }
          }
          if (d.data) {
            const tempFields = addDefaultValuesToFields([...fields], d.data);
            const tempFields2 = tempFields.map((e) => {
              const semilarField = defaultValue[e.name];

              if (semilarField && e.name !== "vehicle_damages") {
                if (Array.isArray(e.defaultValue)) {
                  if (Array.isArray(semilarField)) {
                    const ma = mergeArrays(semilarField, e.defaultValue);
                    return { ...e, defaultValue: ma };
                  }
                } else {
                  return { ...e, defaultValue: semilarField };
                }
              }

              return e;
            });

            setFields(tempFields2);
            setSingleRelatedFields({ [name]: tempFields2 });
          }
          setLoading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const [_fields, setFields] = useState(fields);

  const [cardData, setCardData] = useState(initData(defaultValue));

  useEffect(() => {
    setFormKey((prevKey) => prevKey + 1);
  }, [_fields]);

  useEffect(() => {
    let e = {
      target: {
        name: relatedParam || relatedParam2,
        value: cardData,
      },
    };
    if (Array.isArray(affectsOn)) {
      e.others = [];
      affectsOn.forEach((elem) => {
        if (elem.name && elem.subname && elem.operation) {
          let condition = "";
          // if(updatedTempfield.affectsOn.condition && updatedTempfield.affectsOn.compareWith){
          //   condition = findDataInObject(toAddData,updatedTempfield.affectsOn.compareWith)
          // }
          if (
            cardData[elem.subname] &&
            (elem.condition ? elem.condition === condition : true)
          ) {
            const newValue = cardData[elem.subname];
            e.others.push({
              target: {
                name: elem.name,
                value: newValue,
              },
            });
          } else {
          }
        }
      });
    }
    if (JSON.stringify(defaultValue) !== JSON.stringify(cardData)) {
      handleChange(e, false);
    }
  }, [cardData]);

  useEffect(() => {
    const tempD = initData(defaultValue);
    if (tempD.id && url) {
      getData(url, tempD.id, tempD);
    } else {
      setLoading(false);
    }
  }, []);

  const onPopUpSubmit = async (data, hasFiles, concatData, relatedPropName) => {
    const temp = [..._fields];
    const fieldIndex = _fields?.findIndex((x) => x.name === relatedPropName);

    let toAddData = Object.assign({}, concatData, data);
    toAddData.new = toAddData.id ? false : true;

    if (fieldIndex !== -1) {
      if (hasFileInput(data) && fieldIndex !== -1) {
        const apiRoute = temp[fieldIndex].apiUrl;
        const parentParam = temp[fieldIndex].parentParam;
        if (concatData.id && temp[fieldIndex].apiUrl) {
          const editValues = getDifferingValues(temp, concatData, false);
          const response = await axios
            .put(
              config.apiUrl + "/api/" + apiRoute + "/" + concatData.id,
              editValues,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${getCookie("_AT")}`,
                },
              }
            )
            .catch((e) => {
              console.log(e.message);
              setpopupData({
                isError: true,
                title: "An Error Occured",
                description: e.response?.data?.error?.message || e.message,
                showPopUp: true,
                hideCancel: true,
              });
            });

          if (response?.headers?.authorization) {
            if (
              `Bearer ${getCookie("_AT")}` !== response.headers.authorization
            ) {
              setCookie("_AT", response.headers.authorization.split(" ")[1]);
            }
          }
          if (response?.data) {
            let filesToUpload = extractFiles(data);

            if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
              for (const fileToUpload of filesToUpload) {
                const fileToUploadValue = fileToUpload.value;
                const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                const totalChunks = Math.ceil(
                  fileToUploadValue.size / chunkSize
                );
                const chunkProgress = 100 / totalChunks;
                let chunkNumber = 0;
                let start = 0;
                let end = 0;
                setpopupData({
                  title: "Uploading",
                  description: fileToUploadValue.name,
                  showPopUp: true,
                  hideCancel: true,
                  hideMainButton: true,
                  showLoading: true,
                  progressValue: 0,
                });

                const uploadNextChunk = async () => {
                  if (end <= fileToUploadValue.size) {
                    start = end;
                    end = start + chunkSize;
                    const chunk = fileToUploadValue.slice(start, end);
                    const fd = new FormData();
                    fd.append("file", chunk);
                    fd.append("chunkNumber", chunkNumber);
                    fd.append("totalChunks", totalChunks);
                    fd.append("originalname", fileToUploadValue.name);
                    fd.append("type", fileToUploadValue.type);
                    fd.append("size", fileToUploadValue.size);
                    fd.append("param", fileToUpload.param || "");
                    fd.append("isMulti", fileToUpload.isMulti || false);
                    const ufResp = await axios.post(
                      config.apiUrl +
                        "/api/" +
                        apiRoute +
                        "/upload/" +
                        response.data?.id,
                      fd,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    );
                    setpopupData({
                      title: "Uploading",
                      description: fileToUploadValue.name,
                      showPopUp: true,
                      hideCancel: true,
                      hideMainButton: true,
                      showLoading: true,
                      progressValue: Number((chunkNumber + 1) * chunkProgress),
                    });
                    chunkNumber++;

                    await uploadNextChunk();
                  }
                };

                await uploadNextChunk();
              }
            }

            setpopupData({
              showPopUp: false,
            });

            //temoToAddData = response.data;
          }
        } else if (apiRoute && parentParam) {
          const dataToSend = Object.assign({}, concatData, data);

          // for damages in reservation page
          if (parentParam === "vehicle") {
            const vehicleId = findDataInFields(currentFields, "vehicle.id");

            if (
              vehicleId == null ||
              (typeof vehicleId === "string" && vehicleId.trim() === "")
            ) {
              dataToSend[parentParam] = editId;
            } else {
              dataToSend[parentParam] = findDataInFields(
                currentFields,
                "vehicle.id"
              );
            }
          } else {
            dataToSend[parentParam] = editId;
          }
          // dataToSend[parentParam] = editId;

          const response = await axios
            .post(config.apiUrl + "/api/" + apiRoute + "/add", dataToSend, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getCookie("_AT")}`,
              },
            })
            .catch((e) => {
              console.log(e.message);
              setpopupData({
                isError: true,
                title: "An Error Occured",
                description: e.response?.data?.error?.message || e.message,
                showPopUp: true,
                hideCancel: true,
              });
            });

          if (response?.headers?.authorization) {
            if (
              `Bearer ${getCookie("_AT")}` !== response.headers.authorization
            ) {
              setCookie("_AT", response.headers.authorization.split(" ")[1]);
            }
          }
          if (response?.data) {
            let filesToUpload = extractFiles(dataToSend);

            if (Array.isArray(filesToUpload) && filesToUpload.length > 0) {
              for (const fileToUpload of filesToUpload) {
                const fileToUploadValue = fileToUpload.value;
                const chunkSize = 0.5 * 1024 * 1024; // 2MB (adjust based on your requirements)
                const totalChunks = Math.ceil(
                  fileToUploadValue.size / chunkSize
                );
                const chunkProgress = 100 / totalChunks;
                let chunkNumber = 0;
                let start = 0;
                let end = 0;
                setpopupData({
                  title: "Uploading",
                  description: fileToUploadValue.name,
                  showPopUp: true,
                  hideCancel: true,
                  hideMainButton: true,
                  showLoading: true,
                  progressValue: 0,
                });

                const uploadNextChunk = async () => {
                  if (end <= fileToUploadValue.size) {
                    start = end;
                    end = start + chunkSize;
                    const chunk = fileToUploadValue.slice(start, end);
                    const fd = new FormData();
                    fd.append("file", chunk);
                    fd.append("chunkNumber", chunkNumber);
                    fd.append("totalChunks", totalChunks);
                    fd.append("originalname", fileToUploadValue.name);
                    fd.append("type", fileToUploadValue.type);
                    fd.append("size", fileToUploadValue.size);
                    fd.append("param", fileToUpload.param || "");
                    fd.append("isMulti", fileToUpload.isMulti || false);
                    const ufResp = await axios.post(
                      config.apiUrl +
                        "/api/" +
                        apiRoute +
                        "/upload/" +
                        response.data?.id,
                      fd,
                      {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${getCookie("_AT")}`,
                        },
                      }
                    );
                    setpopupData({
                      title: "Uploading",
                      description: fileToUploadValue.name,
                      showPopUp: true,
                      hideCancel: true,
                      hideMainButton: true,
                      showLoading: true,
                      progressValue: Number((chunkNumber + 1) * chunkProgress),
                    });
                    chunkNumber++;

                    await uploadNextChunk();
                  }
                };

                await uploadNextChunk();
              }
            }

            setpopupData({
              showPopUp: false,
            });

            toAddData = Object.assign({}, response.data, data);
          }
        }
      }

      const field = { ...temp[fieldIndex] };
      let oldRelated = field.defaultValue ? [...field.defaultValue] : [];
      if (toAddData.new) {
        if (toAddData.tempid) {
          if (Array.isArray(oldRelated)) {
            const indexToEdit = oldRelated.findIndex(
              (x) => x.tempid == toAddData.tempid
            );

            if (indexToEdit !== -1) {
              // If an object with the same id is found, replace it with toAddData
              if (toAddData.delete) {
                //Delete from array
                oldRelated.splice(indexToEdit, 1);
              } else {
                oldRelated[indexToEdit] = toAddData;
              }
            } else {
              // If no object with the same id is found, add toAddData to the array
              oldRelated.push(toAddData);
            }
          }
        } else {
          // If toAddData has no id, simply add it to the array
          if (Array.isArray(oldRelated)) {
            toAddData.tempid = oldRelated.length + 1;
            oldRelated.push(toAddData);
          }
        }
      } else {
        if (toAddData.id) {
          const indexToEdit = oldRelated.findIndex((x) => x.id == toAddData.id);
          toAddData.changed = true;
          if (indexToEdit !== -1) {
            // If an object with the same id is found, replace it with toAddData
            oldRelated[indexToEdit] = toAddData;
          } else {
            // If no object with the same id is found, add toAddData to the array
            oldRelated.push(toAddData);
          }
        } else {
          // If toAddData has no id, simply add it to the array
          toAddData.tempid = oldRelated.length + 1;
          oldRelated.push(toAddData);
        }
      }
      field.defaultValue = [...oldRelated];
      temp[fieldIndex] = field;

      setFields(temp);
      const _e = {
        target: {
          name: relatedParam || relatedParam2,
          value: temp,
        },
      };
      setCardData((prev) => {
        return {
          ...prev,
          [relatedPropName]: field.defaultValue.filter(
            (x) => x.new || x.changed
          ),
        };
      });
    }
    resetPopUp();
  };

  const handleRelatedData = (data, name, action, subname) => {
    const field = _fields?.find((x) => x.name === name);

    const errorCheck =
      field &&
      field.formOptions &&
      Array.isArray(field.formOptions.fields) &&
      field.formOptions.fields.length > 0;
    const clickedDefaultValue =
      data && (data.id || data.tempid) && errorCheck && field.defaultValue
        ? field.defaultValue.find((x) =>
            x.id ? x.id == data.id : x.tempid ? x.tempid == data.tempid : false
          )
        : null;

    if (action && errorCheck) {
      const toUpdate = clickedDefaultValue
        ? addDefaultValuesToFields(
            field.formOptions.fields,
            clickedDefaultValue
          )
        : field.formOptions.fields;

      switch (action) {
        case "view":
          setpopupData({
            title: "View",
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: null,
            formConcatData: {},
            propName: name,
            disabledForm: true,
          });
          break;
        case "edit":
          setpopupData({
            title: "Edit",
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: onPopUpSubmit,
            formConcatData: clickedDefaultValue,
            propName: name,
            disabledForm: false,
          });
          break;
        case "update":
          onPopUpSubmit(data, false, clickedDefaultValue, name);
          break;
        case "add":
          setpopupData({
            title: "New",
            formOptions: toUpdate,
            showPopUp: true,
            formSubmit: onPopUpSubmit,
            formConcatData: data
              ? Object.assign({}, data, clickedDefaultValue ?? {})
              : clickedDefaultValue ?? {},
            propName: subname ? subname : name,
            disabledForm: false,
          });
          break;
        default:
          break;
      }
    } else {
      if (errorCheck) {
        setpopupData({
          title: field.formOptions.label,
          formOptions: field.formOptions.fields,
          showPopUp: true,
          formSubmit: onPopUpSubmit,
          formConcatData: data,
          propName: name,
          disabledForm: false,
        });
      }
    }
  };

  const resetPopUp = () => {
    setpopupData({});
  };

  const handleInputChange = (data, param, type) => {
    if (type === "file") {
      handleChange({
        target: {
          name: (relatedParam || relatedParam2) + "_" + param,
          type: "file",
          files: data[param],
          value: data[param],
        },
      });
    } else {
      setSingleRelatedFieldsFormData({ [param]: data[param] });
      setCardData((prev) => {
        return { ...prev, [param]: data[param] };
      });
    }
  };

  return (
    <div className="w-full rounded-lg shadow">
      {label && <SimpleHeading label={label} />}
      <div className="p-4">
        {loading && (
          <div className="text-center w-full">
            <PropagateLoader color="#5729BC" />
          </div>
        )}

        {!loading && (
          <ReusableForm
            key={formKey}
            fields={_fields}
            hideSubmitActions={true}
            handleRelatedData={handleRelatedData}
            customHandleInput={handleInputChange}
            id={parentId}
            forcedErrors={err}
          />
        )}

        <PopUp
          isError={popupData.isError}
          title={popupData.title}
          description={popupData.description}
          formOptions={popupData.formOptions}
          takeActionText={popupData.takeActionText}
          showPopUp={popupData.showPopUp}
          hidePopUp={resetPopUp}
          formSubmit={popupData.formSubmit}
          formConcatData={popupData.formConcatData}
          propName={popupData.propName}
          disabledForm={popupData.disabledForm}
        />
      </div>
    </div>
  );
};

export default SingleRelatedCard;
